// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* .download-main-container{
    display:flex;
    justify-content: flex-end;
    width:92%;
    height:100vh;
    background:transparent;
    position:static;
    z-index:999;
} */
:root {
    --sidebar-width: 256px;/* Define the width of your sidebar */
    --sidebar-height:100% ;
  }
.download-container{
    display:flex;
    flex-direction: column;
    width:20%;
    height:100%;
    background-color: white;  
    font-family: "PlusJakartaSans";
    border-radius: 1rem;
    right:0%;
    top:0%;
    position:absolute;
    z-index:100;
    box-shadow: 1px 2px 9px rgb(219, 219, 219);
}
.download-header{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width:100%;
    font-weight: 600;
    margin-bottom:2rem;
    background-color: rgb(13, 13, 48);
    color:white;
    padding:1.5rem;
}
label{
    margin-bottom: 0.25rem;
}
.download-margin-container{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items:center;
    height:100%;
    padding: 1.5rem;
}
.download-content{
    display: flex;
    flex-direction:column;
    width:100%;
}

.date-container{
    display:flex;
    flex-direction:column;
    align-items: flex-start;
    justify-content: center;
}
.download-calender-container{
    display: flex;
    align-items: center;
    width:100%;
    justify-content: space-between;
    padding:0.75rem;
    border:1px solid rgb(196, 196, 196);
    border-radius:0.25rem;
}
.calender-container span{
    font-size:14px;
}
.time-container{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
}
.time-header-label{
    margin-bottom: 0.75rem;
    font-weight:600;
    color:rgb(22, 28, 36)
}
.from-to-container{
    display: flex;
    width:100%;
    align-items: center;
    justify-content: space-between;
}
.time-in{
    display:flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    width:48%;
}
.time{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    border:1px solid rgb(223, 227, 232);
    border-radius:0.25rem;
}
.time-in div:hover{
    cursor:pointer;
}
.download-footer{
    display: flex;
    align-items:center;
    justify-content: flex-end;
    width:100%;
    padding:0.5rem;
    padding-left:1.5rem;
    padding-right:1.5rem; 
    font-family: "PlusJakartaSans";
    box-shadow: 1px 2px 9px rgb(219, 219, 219);
}
.footer-btn-container{
   display:flex;
   width: -moz-fit-content;
   width: fit-content;
   height: -moz-fit-content;
   height: fit-content;
   background-color: white;
   border-radius:0.25rem; 
   gap:1rem;
}
.download-cancel-btn,.download-download-btn{
    display: flex;
    align-items:center;
    justify-content: center;
    text-align:center;
    padding:0.5rem;
    height:2.5rem; 
    border-radius:0.25rem; 
}
.download-download-btn[disabled] {
    background-color: #ccc; /* Change background color when button is disabled */
    color: #666; /* Change text color when button is disabled */
    cursor: not-allowed; /* Change cursor to indicate button is disabled */
    border:2px solid #666;
  }
.download-cancel-btn{
    border:2px solid rgb(64, 64, 242);;
    color:rgb(64, 64, 242);
    background-color: white; 
}
.download-download-btn{
    background-color: rgb(64, 64, 242);
    border:2px solid rgb(64, 64, 242);
    color:white;
}
.calender-div{
 display:flex;
 position:absolute;
 margin-top:30%;
 align-items:center;
 justify-content: center;
 width:100%;
}
.rdrCalendarWrapper{
    width:95%;
}
.rdrDateDisplayItemActive{
    border: 1px solid rgb(64, 64, 242) !important;
}
.rdrMonths,.rdrMonth{
    width:100%;
    align-items: center;
    justify-content: center;
}
.rdrInRange{
 background-color:rgb(217, 217, 252) !important;
}
.rdrStartEdge,.rdrEndEdge{
    background-color:rgb(64, 64, 242) !important;
    color:white !important;
    /* width:80%; */
    /*height:100%; */
    /* border-radius: 50% !important; */
    /* align-items: center !important;
    justify-content: center !important; */
}
.rdrDayStartPreview,.rdrDayEndPreview{
    background-color:rgb(64, 64, 242) !important;
    color:white !important;
}
.rdrDayHovered > span,.rdrDayHovered > span > span,.rdrDay > span,.rdrDayInPreview{
    color:white !important;
}
.rdrDayNumber{
    z-index:10;
    color:white;
}
.popup-close-button:hover{
   cursor: pointer;
}
@media only screen and (max-width: 1281px) and (min-width: 720px) {

  
  }
  @media only screen and (max-height: 700px) and (min-height: 300px) {

    .download-header{
        padding:0.75rem;
        margin-bottom:0;
    }

    .download-margin-container{

        padding: 0.75rem;
    }

    
    }`, "",{"version":3,"sources":["webpack://./src/pages/report/components/Download/Download.css"],"names":[],"mappings":";AACA;;;;;;;;GAQG;AACH;IACI,sBAAsB,CAAC,qCAAqC;IAC5D,sBAAsB;EACxB;AACF;IACI,YAAY;IACZ,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,8BAA8B;IAC9B,mBAAmB;IACnB,QAAQ;IACR,MAAM;IACN,iBAAiB;IACjB,WAAW;IACX,0CAA0C;AAC9C;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;IACjC,WAAW;IACX,cAAc;AAClB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;AACA;IACI,aAAa;IACb,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,uBAAuB;IACvB,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,8BAA8B;IAC9B,eAAe;IACf,mCAAmC;IACnC,qBAAqB;AACzB;AACA;IACI,cAAc;AAClB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;AAC3B;AACA;IACI,sBAAsB;IACtB,eAAe;IACf;AACJ;AACA;IACI,aAAa;IACb,UAAU;IACV,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,YAAY;IACZ,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;AACb;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,mCAAmC;IACnC,qBAAqB;AACzB;AACA;IACI,cAAc;AAClB;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;IACV,cAAc;IACd,mBAAmB;IACnB,oBAAoB;IACpB,8BAA8B;IAC9B,0CAA0C;AAC9C;AACA;GACG,YAAY;GACZ,uBAAkB;GAAlB,kBAAkB;GAClB,wBAAmB;GAAnB,mBAAmB;GACnB,uBAAuB;GACvB,qBAAqB;GACrB,QAAQ;AACX;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,qBAAqB;AACzB;AACA;IACI,sBAAsB,EAAE,oDAAoD;IAC5E,WAAW,EAAE,8CAA8C;IAC3D,mBAAmB,EAAE,iDAAiD;IACtE,qBAAqB;EACvB;AACF;IACI,iCAAiC;IACjC,sBAAsB;IACtB,uBAAuB;AAC3B;AACA;IACI,kCAAkC;IAClC,iCAAiC;IACjC,WAAW;AACf;AACA;CACC,YAAY;CACZ,iBAAiB;CACjB,cAAc;CACd,kBAAkB;CAClB,uBAAuB;CACvB,UAAU;AACX;AACA;IACI,SAAS;AACb;AACA;IACI,6CAA6C;AACjD;AACA;IACI,UAAU;IACV,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;CACC,8CAA8C;AAC/C;AACA;IACI,4CAA4C;IAC5C,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,mCAAmC;IACnC;yCACqC;AACzC;AACA;IACI,4CAA4C;IAC5C,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,UAAU;IACV,WAAW;AACf;AACA;GACG,eAAe;AAClB;AACA;;;EAGE;EACA;;IAEE;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;;QAEI,gBAAgB;IACpB;;;IAGA","sourcesContent":["\r\n/* .download-main-container{\r\n    display:flex;\r\n    justify-content: flex-end;\r\n    width:92%;\r\n    height:100vh;\r\n    background:transparent;\r\n    position:static;\r\n    z-index:999;\r\n} */\r\n:root {\r\n    --sidebar-width: 256px;/* Define the width of your sidebar */\r\n    --sidebar-height:100% ;\r\n  }\r\n.download-container{\r\n    display:flex;\r\n    flex-direction: column;\r\n    width:20%;\r\n    height:100%;\r\n    background-color: white;  \r\n    font-family: \"PlusJakartaSans\";\r\n    border-radius: 1rem;\r\n    right:0%;\r\n    top:0%;\r\n    position:absolute;\r\n    z-index:100;\r\n    box-shadow: 1px 2px 9px rgb(219, 219, 219);\r\n}\r\n.download-header{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    width:100%;\r\n    font-weight: 600;\r\n    margin-bottom:2rem;\r\n    background-color: rgb(13, 13, 48);\r\n    color:white;\r\n    padding:1.5rem;\r\n}\r\nlabel{\r\n    margin-bottom: 0.25rem;\r\n}\r\n.download-margin-container{\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n    align-items:center;\r\n    height:100%;\r\n    padding: 1.5rem;\r\n}\r\n.download-content{\r\n    display: flex;\r\n    flex-direction:column;\r\n    width:100%;\r\n}\r\n\r\n.date-container{\r\n    display:flex;\r\n    flex-direction:column;\r\n    align-items: flex-start;\r\n    justify-content: center;\r\n}\r\n.download-calender-container{\r\n    display: flex;\r\n    align-items: center;\r\n    width:100%;\r\n    justify-content: space-between;\r\n    padding:0.75rem;\r\n    border:1px solid rgb(196, 196, 196);\r\n    border-radius:0.25rem;\r\n}\r\n.calender-container span{\r\n    font-size:14px;\r\n}\r\n.time-container{\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    justify-content: center;\r\n}\r\n.time-header-label{\r\n    margin-bottom: 0.75rem;\r\n    font-weight:600;\r\n    color:rgb(22, 28, 36)\r\n}\r\n.from-to-container{\r\n    display: flex;\r\n    width:100%;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n.time-in{\r\n    display:flex;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    justify-content: space-between;\r\n    width:48%;\r\n}\r\n.time{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    border:1px solid rgb(223, 227, 232);\r\n    border-radius:0.25rem;\r\n}\r\n.time-in div:hover{\r\n    cursor:pointer;\r\n}\r\n.download-footer{\r\n    display: flex;\r\n    align-items:center;\r\n    justify-content: flex-end;\r\n    width:100%;\r\n    padding:0.5rem;\r\n    padding-left:1.5rem;\r\n    padding-right:1.5rem; \r\n    font-family: \"PlusJakartaSans\";\r\n    box-shadow: 1px 2px 9px rgb(219, 219, 219);\r\n}\r\n.footer-btn-container{\r\n   display:flex;\r\n   width: fit-content;\r\n   height: fit-content;\r\n   background-color: white;\r\n   border-radius:0.25rem; \r\n   gap:1rem;\r\n}\r\n.download-cancel-btn,.download-download-btn{\r\n    display: flex;\r\n    align-items:center;\r\n    justify-content: center;\r\n    text-align:center;\r\n    padding:0.5rem;\r\n    height:2.5rem; \r\n    border-radius:0.25rem; \r\n}\r\n.download-download-btn[disabled] {\r\n    background-color: #ccc; /* Change background color when button is disabled */\r\n    color: #666; /* Change text color when button is disabled */\r\n    cursor: not-allowed; /* Change cursor to indicate button is disabled */\r\n    border:2px solid #666;\r\n  }\r\n.download-cancel-btn{\r\n    border:2px solid rgb(64, 64, 242);;\r\n    color:rgb(64, 64, 242);\r\n    background-color: white; \r\n}\r\n.download-download-btn{\r\n    background-color: rgb(64, 64, 242);\r\n    border:2px solid rgb(64, 64, 242);\r\n    color:white;\r\n}\r\n.calender-div{\r\n display:flex;\r\n position:absolute;\r\n margin-top:30%;\r\n align-items:center;\r\n justify-content: center;\r\n width:100%;\r\n}\r\n.rdrCalendarWrapper{\r\n    width:95%;\r\n}\r\n.rdrDateDisplayItemActive{\r\n    border: 1px solid rgb(64, 64, 242) !important;\r\n}\r\n.rdrMonths,.rdrMonth{\r\n    width:100%;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n.rdrInRange{\r\n background-color:rgb(217, 217, 252) !important;\r\n}\r\n.rdrStartEdge,.rdrEndEdge{\r\n    background-color:rgb(64, 64, 242) !important;\r\n    color:white !important;\r\n    /* width:80%; */\r\n    /*height:100%; */\r\n    /* border-radius: 50% !important; */\r\n    /* align-items: center !important;\r\n    justify-content: center !important; */\r\n}\r\n.rdrDayStartPreview,.rdrDayEndPreview{\r\n    background-color:rgb(64, 64, 242) !important;\r\n    color:white !important;\r\n}\r\n.rdrDayHovered > span,.rdrDayHovered > span > span,.rdrDay > span,.rdrDayInPreview{\r\n    color:white !important;\r\n}\r\n.rdrDayNumber{\r\n    z-index:10;\r\n    color:white;\r\n}\r\n.popup-close-button:hover{\r\n   cursor: pointer;\r\n}\r\n@media only screen and (max-width: 1281px) and (min-width: 720px) {\r\n\r\n  \r\n  }\r\n  @media only screen and (max-height: 700px) and (min-height: 300px) {\r\n\r\n    .download-header{\r\n        padding:0.75rem;\r\n        margin-bottom:0;\r\n    }\r\n\r\n    .download-margin-container{\r\n\r\n        padding: 0.75rem;\r\n    }\r\n\r\n    \r\n    }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
